import { ActionReducerMap, createFeatureSelector, createSelector } from '@ngrx/store';
import { State as AppState } from '../../../core/store/reducers';
import * as fromDocumentRequestBatch from './document-request-batch.reducer';

export const documentRequestBatchesFeatureKey = 'documentRequestBatches';

export interface State extends AppState {
  [documentRequestBatchesFeatureKey]: DocumentRequestBatchesState;
}

export interface DocumentRequestBatchesState {
  [fromDocumentRequestBatch.documentRequestBatchFeatureKey]: fromDocumentRequestBatch.State;
}

export const reducers: ActionReducerMap<DocumentRequestBatchesState> = {
  [fromDocumentRequestBatch.documentRequestBatchFeatureKey]: fromDocumentRequestBatch.reducer,
};

export const selectDocumentRequestBatchesFeatureState =
  createFeatureSelector<DocumentRequestBatchesState>(documentRequestBatchesFeatureKey);

export const selectDocumentRequestBatchState = createSelector(
  selectDocumentRequestBatchesFeatureState,
  (state) => state[fromDocumentRequestBatch.documentRequestBatchFeatureKey]
);

export const selectGeneratedFiles = createSelector(selectDocumentRequestBatchState, (state) => state.generatedFiles);

export const selectIsLoading = createSelector(selectGeneratedFiles, (state) => state.isLoading);

export const selectError = createSelector(selectGeneratedFiles, (state) => state.error);

export const selectClientGeneratedFiles = createSelector(selectDocumentRequestBatchState, (state) => state.clientGeneratedFiles);

export const selectClientIsLoading = createSelector(selectClientGeneratedFiles, (state) => state.isLoading);

export const selectClientError = createSelector(selectClientGeneratedFiles, (state) => state.error);

export const selectDocumentOverview = createSelector(selectDocumentRequestBatchState, (state) => state.documentOverview);

export const selectClientDocumentOverview = createSelector(selectDocumentRequestBatchState, (state) => state.clientDocumentOverview);
